<template>
	<div id="create-modal">
		<div v-if="!!serverBusy" id="server-activity-loading">
			<span class="loading-icon"></span>
			<span class="loading-message">{{ busyText }}</span>
		</div>
		<div id="create-container">
			<fieldset>
				<legend>Create Buy-In Offer</legend>
				<p class="yellow-text" style="text-align: center">
					If you want to schedule this buy in click on the Create Schedule button
				</p>
				<div class="label-input">
					<label for="offer-name" title="name">Offer Name</label>
					<input type="text" id="offer-name" name="Offer Name" :maxlength="maxLengthOfBuyInOffer" placeholder="Offer Name" title="Offer Name" v-model="name" />
				</div>
				<div v-if="playThroughMultiplier <= 0" class="label-input">
					<label
						for="regular-coc"
						:title="`Regular Credit (${systemCurrencyTool.currencyInfo.symbol}) per ${systemCurrencyTool.formatFromAU(
							systemCurrencyTool.currencyInfo.auPerCurrencyUnit
						)} cash`"
						>Regular Credit ({{ systemCurrencyTool.currencyInfo.symbol }}) per
						{{ systemCurrencyTool.formatFromAU(systemCurrencyTool.currencyInfo.auPerCurrencyUnit) }}
						cash</label
					>
					<input
						type="number"
						id="regular-coc"
						name="regular-coc"
						onkeydown="return event.keyCode !== 69 && event.keyCode !== 189 && event.key !== '-'"
						:placeholder="`Regular Credit (${systemCurrencyTool.currencyInfo.symbol}) per ${systemCurrencyTool.formatFromAU(
							systemCurrencyTool.currencyInfo.auPerCurrencyUnit
						)} cash`"
						:title="`Regular Credit (${systemCurrencyTool.currencyInfo.symbol}) per ${systemCurrencyTool.formatFromAU(
							systemCurrencyTool.currencyInfo.auPerCurrencyUnit
						)} cash`"
						v-model="regularCashCOC"
						min="0"
					/>
					<!-- 69 is the e/E value in unix code -->
					<!-- 189 is the - value in unix code -->
				</div>
				<div v-else class="label-input">
					<label
						for="regular-coc"
						:title="`Regular Credit (${systemCurrencyTool.currencyInfo.symbol}) per ${systemCurrencyTool.formatFromAU(
							systemCurrencyTool.currencyInfo.auPerCurrencyUnit
						)} cash`"
						>Regular Credit ({{ systemCurrencyTool.currencyInfo.symbol }}) per
						{{ systemCurrencyTool.formatFromAU(systemCurrencyTool.currencyInfo.auPerCurrencyUnit) }}
						cash</label
					>
					<input
						disabled
						type="number"
						id="regular-coc"
						name="regular-coc"
						onkeydown="return event.keyCode !== 69 && event.keyCode !== 189 && event.key !== '-'"
						:placeholder="`Regular Credit (${systemCurrencyTool.currencyInfo.symbol}) per ${systemCurrencyTool.formatFromAU(
							systemCurrencyTool.currencyInfo.auPerCurrencyUnit
						)} cash`"
						:title="`Regular Credit (${systemCurrencyTool.currencyInfo.symbol}) per ${systemCurrencyTool.formatFromAU(
							systemCurrencyTool.currencyInfo.auPerCurrencyUnit
						)} cash`"
						v-model="regularCashCOC"
						min="0"
					/>
				</div>
				<div class="label-input">
					<label
						for="promo-coc"
						:title="`Promo Credit (${systemCurrencyTool.currencyInfo.symbol}) per ${systemCurrencyTool.formatFromAU(
							systemCurrencyTool.currencyInfo.auPerCurrencyUnit
						)} cash`"
						>Promo Credit ({{ systemCurrencyTool.currencyInfo.symbol }}) per
						{{ systemCurrencyTool.formatFromAU(systemCurrencyTool.currencyInfo.auPerCurrencyUnit) }}
						cash</label
					>
					<input
						type="number"
						id="promo-coc"
						name="promo-coc"
						onkeydown="return event.keyCode !== 69 && event.keyCode !== 189 && event.key !== '-'"
						:placeholder="`Promo Credit (${systemCurrencyTool.currencyInfo.symbol}) per ${systemCurrencyTool.formatFromAU(
							systemCurrencyTool.currencyInfo.auPerCurrencyUnit
						)} cash`"
						:title="`Promo Credit (${systemCurrencyTool.currencyInfo.symbol}) per ${systemCurrencyTool.formatFromAU(
							systemCurrencyTool.currencyInfo.auPerCurrencyUnit
						)} cash`"
						v-model="promoCashCOC"
						min="0"
					/>
				</div>
				<div class="label-input">
					<label for="minimum" :title="`Minimum Cash Buy-In ${systemCurrencyTool.currencyInfo.symbol}`"
						>Minimum Cash Buy-In {{ systemCurrencyTool.currencyInfo.symbol }}</label
					>
					<input
						type="number"
						id="minimum"
						name="minimum"
						onkeydown="return event.keyCode !== 69 && event.keyCode !== 189 && event.key !== '-'"
						:placeholder="`Minimum Cash Buy-In ${systemCurrencyTool.currencyInfo.symbol}`"
						:title="`Minimum Cash Buy-In ${systemCurrencyTool.currencyInfo.symbol}`"
						v-model="minimumCOC"
						min="0"
					/>
				</div>
				<div class="label-input">
					<label for="maximum" :title="`Maximum Cash Buy-In ${systemCurrencyTool.currencyInfo.symbol}`"
						>Maximum Cash Buy-In {{ systemCurrencyTool.currencyInfo.symbol }}</label
					>
					<input
						type="number"
						id="maximum"
						name="maximum"
						onkeydown="return event.keyCode !== 69 && event.keyCode !== 189 && event.key !== '-'"
						:placeholder="`Maximum Cash Buy-In ${systemCurrencyTool.currencyInfo.symbol}`"
						:title="`Maximum Cash Buy-In ${systemCurrencyTool.currencyInfo.symbol}`"
						v-model="maximumCOC"
						min="0"
					/>
				</div>
				<div class="label-input">
					<label for="priority" title="Priority">Priority</label>
					<input type="number" id="priority" name="priority" onkeydown="return event.keyCode !== 69 && event.keyCode !== 189 && event.key !== '-'" placeholder="Priority" title="Priority" v-model="priority" min="0" />
				</div>
				<div class="label-input">
					<label for="start-date" title="Start Date">Start Date</label>
					<input
						type="datetime-local"
						id="start-date"
						:min="startMin"
						name="start-date"
						placeholder="Start Date"
						title="Start Date"
						v-model="startDate"
					/>
				</div>
				<div class="label-input">
					<label for="end-date" title="End Date">End Date</label>
					<input
						type="datetime-local"
						id="end-date"
						name="end-date"
						:min="endMin"
						:max="endMax"
						placeholder="End Date"
						title="End Date"
						v-model="endDate"
					/>
				</div>
				<div class="label-input">
					<label for="max-cashin-per-cycle" :title="`Max Cash in per cycle ${systemCurrencyTool.currencyInfo.symbol}`"
						>Max Cash in per cycle {{ systemCurrencyTool.currencyInfo.symbol }}</label
					>
					<input
						type="number"
						id="max-cashin-per-cycle"
						name="max-cashin-per-cycle"
						onkeydown="return event.keyCode !== 69 && event.keyCode !== 189 && event.key !== '-'"
						:title="`max-cashin-per-cycle ${systemCurrencyTool.currencyInfo.symbol}`"
						v-model="maxCashInPerCycle"
						min="0"
					/>
				</div>
				<div class="label-input">
					<label for="welcome-back-limit-days" title="Welcome Back Limit Days"
						>Welcome Back Limit Days</label
					>
					<input
						type="number"
						id="welcome-back-limit-days"
						name="welcome-back-limit-days"
						onkeydown="return event.keyCode !== 69 && event.keyCode !== 189 && event.key !== '-'"
						title="welcome-back-limit-days"
						v-model="welcomeBackLimitDays"
						min="0"
					/>
				</div>
				<div class="label-input">
					<label for="play-through-multiplier" title="Play Through Multiplier"
						>Play Through Multiplier</label
					>
					<input
						type="number"
						id="play-through-multiplier"
						name="play-through-multiplier"
						onkeydown="return event.keyCode !== 69 && event.keyCode !== 189 && event.key !== '-'"
						title="play-through-multiplier"
						v-model="playThroughMultiplier"
						min="0"
					/>
				</div>
				<div class="label-input">
					<label for="availableCasinos" title="Available Casinos">Available Casinos</label>
					<select name="available-casino-ids" id="available-casino" v-model="availableCasinoIds" multiple>
						<option v-for="(item,index) in casinoList" :value="item.id">{{ item.name }}</option>
					</select>
				</div>
				<div v-if="scheduleForBuyIn != null && !disableCreateSchedule">
					<label>Buy-In Schedule</label>
					<textarea id="displayScheduleCreateBuyIn"></textarea>
				</div>
				<div class="label-input">
					<label for="status" title="Status">Status</label>
					<select name="offer-status" v-model="offerStatus">
						<option>Active</option>
						<option>Inactive</option>
						<option>Hidden</option>
					</select>
				</div>
				<div class="label-input">
					<label for="cashier-allowed" title="Cashier Allowed">Cashier Allowed</label>
					<input
						type="checkbox"
						id="cashier-allowed"
						name="cashier-allowed"
						title="Cashier Allowed"
						v-model="cashierAllowed"
					/>
				</div>
				<div v-if="!disableCreateSchedule" class="label-input">
					<label for="one-claim-per-window" title="Cashier Allowed">One Claim Per Window</label>
					<input
						type="checkbox"
						id="one-claim-per-window"
						name="one-claim-per-window"
						title="One Claim Per Window"
						v-model="oneClaimPerWindow"
					/>
				</div>
				<!-- <div class="label-input">
					<label for="mru-allowed" title="MRU Allowed">MRU Allowed</label>
					<input type="checkbox" id="mru-allowed" name="mru-allowed" placeholder="MRU Allowed" title="MRU Allowed" v-model="mruAllowed" />
				</div> -->
				<div class="label-input">
					<label for="web-allowed" title="Web Allowed">Web Allowed</label>
					<input type="checkbox" id="web-allowed" name="web-allowed" placeholder="Web Allowed" title="Web Allowed" v-model="webAllowed" />
				</div>
				<div class="button-group">
					<button type="button" class="btn"  @click="createBuyInOffer()" title="Create New Casino">Create New Offer</button>
					<button type="button" class="btn" @click="closeModal()" :title="closeButtonText">{{ closeButtonText }}</button>
					<div v-if="!disableCreateSchedule">
						<button type="button" class="btn" @click="createSchedule()">Create Schedule</button>
					</div>
					
					<!-- <button type="button" @click="createBuyInOfferConfig()" >Test</button> -->
				</div>
			</fieldset>
		</div>
		<transition name="fade">
			<component :is="currentModal" :adminState="adminState" :serverStatus="serverStatus" :systemCurrencyTool="systemCurrencyTool"/>
		</transition>
	</div>
</template>

<script>
import { onBeforeUnmount } from "vue";
import sharedScripts from "@/dependencies/sharedScripts";
import Scheduler from "@/components/Scheduler";

export default {
	name: "CreateBuyInOffer",
	components: {
		Scheduler
	},
	props: {
		adminState: Object,
		serverStatus: Boolean,
		systemCurrencyTool: Object,
		casinoList: Object
	},
	data() {
		return {
			status: Object.assign({}, this.globalStatus),
			timeZoneOffset: new Date().getTimezoneOffset() / 60,
			body: document.querySelector("body"),
			serverBusy: false,
			busyText: "",
			closeButtonText: "Close",
			buyInOffer: {},
			name: "",
			regularCashCOC: 0,
			promoCashCOC: 0,
			minimumCOC: 0,
			maximumCOC: 0,
			startDate: "",
			endDate: "",
			startMin: null,
			startMax: this.startDate,
			endMin: null,
			endMax: null,
			priority: 0,
			cashierAllowed: false,
			mruAllowed: false,
			webAllowed: false,
			currentModal: null,
			offerStatus: null,
			oneClaimPerWindow: null,
			maxCashInPerCycle: null,
			availableCasinoIds: null,
			scheduleForBuyIn: null,
			maxLengthOfBuyInOffer: 64,
			welcomeBackLimitDays: null,
			disableCreateSchedule: false,
			playThroughMultiplier: 0,
		};
	},
	watch: {
		startDate() {
			this.endMin = this.startDate;
		},
		endDate() {
			this.startMax = this.endDate;
		},
		welcomeBackLimitDays() {
			if(this.welcomeBackLimitDays > 0) this.disableCreateSchedule = true;
			else {
				this.disableCreateSchedule = false;
			}
		},
		playThroughMultiplier() {
			if(this.playThroughMultiplier > 0) this.regularCashCOC = 0;
		},
		
	},
	created() {
		let start = new Date();
		start = new Date(start.setHours(start.getHours() - this.timeZoneOffset)).toISOString();
		let end = new Date();
		end = new Date(end.setHours(end.getHours() - this.timeZoneOffset)).toISOString();
		this.startDate = start.slice(0, 16);
		this.endDate = end.slice(0, 16);

		this.eventBus.on("closeSchedulerModal", (serializedData) => {
			this.currentModal = null;
			document.getElementById("displayScheduleCreateBuyIn").value = serializedData;
		});

		onBeforeUnmount(() => {
			this.body.onkeydown = null;
			this.eventBus.off("closeSchedulerModal");
		});
	},
	mounted() {
		this.body.onkeydown = (e) => {
			if (e.key === "Escape") this.closeModal();
		};

		this.eventBus.on("createdSchedule", (payload) =>{
			this.scheduleForBuyIn = payload;
		});
	},
	methods: {
		throwDateTimeError(inputName) {
			this.status.message = `${inputName} is not complete. Must have both the date and time or be left unset/empty.`;
			this.status.ok = false;
			this.eventBus.emit("updateStatus", this.status);
		},
		async createBuyInOffer() {
			let dateErrState = false;

			if (document.getElementById("start-date").validity.badInput) {
				this.throwDateTimeError("Start Date");
				dateErrState = true;
			}

			if (document.getElementById("end-date").validity.badInput) {
				this.throwDateTimeError("End Date");
				dateErrState = true;
			}
			if(this.startDate < this.scheduleForBuyIn?.scheduleStart) {
				this.status.message = "Start Date cannot be before schedule start";
				this.status.ok = false;
				this.eventBus.emit("updateStatus", this.status);
				return false;
			}
			if(this.name.length > this.maxLengthOfBuyInOffer) {
				this.status.message = "Offer name cannot be longer than 64 characters";
				this.status.ok = false;
				this.eventBus.emit("updateStatus", this.status);
				return false;
			}
			let isPlayThroughMultiplierDecimalValue = (this.playThroughMultiplier - Math.floor(this.playThroughMultiplier)) !== 0;
			let isWelcomeBackLimitDaysDecimalValue = (this.welcomeBackLimitDays - Math.floor(this.welcomeBackLimitDays)) !== 0;

			if (dateErrState) return false;

			switch (true) {
				case !this.name:
					this.status.message = "Buy-in offer must have a name.";
					this.status.ok = false;
					this.eventBus.emit("updateStatus", this.status);
					return;
				case this.regularCashCOC < 0:
					this.status.message = "Regular Au per cash unit cannot be a negative number.";
					this.status.ok = false;
					this.eventBus.emit("updateStatus", this.status);
					return;
				case this.promoCashCOC < 0:
					this.status.message = "Promo Au per cash unit cannot be a negative number.";
					this.status.ok = false;
					this.eventBus.emit("updateStatus", this.status);
					return;
				case !this.minimumCOC > 0 || !this.maximumCOC > 0:
					this.status.message = "Minimum and maximum must be greater than 0.";
					this.status.ok = false;
					this.eventBus.emit("updateStatus", this.status);
					return;
				case this.minimumCOC < 0 || this.maximumCOC < 0:
					this.status.message = "Minimum and maximum cannot be less than 0.";
					this.status.ok = false;
					this.eventBus.emit("updateStatus", this.status);
					return;
				case !this.priority > 0:
					this.status.message = "Priority must be greater than 0.";
					this.status.ok = false;
					this.eventBus.emit("updateStatus", this.status);
					return;
				case this.priority < 0:
					this.status.message = "Priority cannot be less than 0.";
					this.status.ok = false;
					this.eventBus.emit("updateStatus", this.status);
					return;
				case this.welcomeBackLimitDays < 0:
					this.status.message = "Welcome Back Limit Days cannot be less than 0";
					this.status.ok = false;
					this.eventBus.emit("updateStatus", this.status);
					return;
				case this.playThroughMultiplier < 0:
					this.status.message = "Play Through Multiplier cannot be less than 0";
					this.status.ok = false;
					this.eventBus.emit("updateStatus", this.status);
					return;
				case isPlayThroughMultiplierDecimalValue:
					this.status.message = "Play Through Multiplier must be a whole number (no decimal allowed)";
					this.status.ok = false;
					this.eventBus.emit("updateStatus", this.status);
					return;
				case isWelcomeBackLimitDaysDecimalValue:
					this.status.message = "Welcome Back Limit Days must be a whole number (no decimals allowed)";
					this.status.ok = false;
					this.eventBus.emit("updateStatus", this.status);
					return;
			}

			// Check if session needs to be refreshed
			let success = await this.authenticationCheck(this);
			if (success.hasOwnProperty("ok") && !success.ok) {
				this.serverBusy = false;
				this.busyText = "";
				return false;
			}

			this.busyText = "Saving";
			this.serverBusy = true;
			this.status.ok = true;

			let body = {
				BuyInOffer: this.createBuyInOfferConfig(),
			};

			let requestUrl = new URL("/api/v1/offer/", this.rabbitsfootHostUrl);
			let headerObj = new Headers();
			headerObj.append("Authorization", `Bearer ${this.adminState.accessToken}`);
			headerObj.append("Content-Type", "application/json; charset=utf-8");
			let request = new Request(requestUrl.toString(), {
				method: "POST",
				body: JSON.stringify(body),
				headers: headerObj,
			});

			try {
				let response = await fetch(request);

				let fetchStatus = sharedScripts.checkFetchErrors(response);

				if (fetchStatus && !fetchStatus.ok) {
					this.serverBusy = false;
					this.busyText = "";
					this.eventBus.emit("updateStatus", fetchStatus);
					if (fetchStatus.forceLogout) this.eventBus.emit("forceLogout");
					return false;
				}

				let dataJson = await response.json();
				//console.log("this is the data Json", dataJson);
				this.status.message = `${dataJson.buyInOffer.publicName} has been created.`;
				this.status.code = fetchStatus.code;
				this.status.ok = fetchStatus.ok;
				this.eventBus.emit("updateStatus", this.status);

				this.eventBus.emit("updateBuyInList");

				this.serverBusy = false;
				this.busyText = "";
				this.closeModal();
			} catch (e) {
				this.serverBusy = false;
				this.status.code = e;
				this.status.ok = false;
				this.userMustDismiss = true;
				this.eventBus.emit("updateStatus", this.status);
				console.error(e);
				return false;
			}
		},
		closeModal() {
			this.eventBus.emit("closeCreateOfferModal");
		},

		createSchedule() {
			this.currentModal = "Scheduler";
		},

		createBuyInOfferConfig() {
			let buyInOfferConfig = {};
			buyInOfferConfig.AdminName = this.adminState.displayName;
			buyInOfferConfig.PublicName = this.name;
			buyInOfferConfig.CreditRegularAUPerCashCOC = this.regularCashCOC * this.systemCurrencyTool.currencyInfo.auPerCurrencyUnit;
			buyInOfferConfig.CreditPromoAUPerCashCOC = this.promoCashCOC * this.systemCurrencyTool.currencyInfo.auPerCurrencyUnit;
			buyInOfferConfig.MinimumCOC = this.minimumCOC;
			buyInOfferConfig.MaximumCOC = this.maximumCOC;
			buyInOfferConfig.StartDate = this.startDate ? this.formatDateTimeISOString(this.startDate, false) : null;
			buyInOfferConfig.EndDate = this.endDate ? this.formatDateTimeISOString(this.endDate, false) : null;
			buyInOfferConfig.Priority = this.priority;
			buyInOfferConfig.CashierAllowed = this.cashierAllowed;
			buyInOfferConfig.WebAllowed = this.webAllowed;
			buyInOfferConfig.Status = this.offerStatus;
			buyInOfferConfig.Schedule = this.scheduleForBuyIn;
			buyInOfferConfig.OnlyOneClaimPerWindow = this.disableCreateSchedule ? false : this.oneClaimPerWindow;
			buyInOfferConfig.MaxCashInPerCycleCOC = this.maxCashInPerCycle;
			buyInOfferConfig.AvailableCasinoIds = this.availableCasinoIds;
			buyInOfferConfig.WelcomeBackLimitDays = this.disableCreateSchedule ? this.welcomeBackLimitDays : 0;
			buyInOfferConfig.playThroughMultiplier = this.playThroughMultiplier;
			// console.log("this is the buy in offer config", buyInOfferConfig);
			return buyInOfferConfig;
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#server-activity-loading {
	display: grid;
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	padding: 30px;
	z-index: 9999;
	transition: background-color 0.3s ease-in-out;
	background-color: rgb(0 0 0 / 80%);
	color: #fff;
}

#server-activity-loading {
	text-align: center;
	align-content: center;
}

#create-modal {
	position: fixed;
	display: grid;
	height: 100vh;
	top: 0;
	right: 0;
	bottom: 0;
	left: 20%;
	background-color: rgb(0 0 0 / 75%);
	-webkit-backdrop-filter: blur(6px);
	backdrop-filter: blur(6px);
	z-index: 1;
}

#create-container {
	display: flex;
	flex-flow: column nowrap;
	position: relative;
	top: 15px;
	right: 0;
	bottom: 0;
	left: 0;
	background-color: #222;
	color: #fff;
	width: 90%;
	margin: auto;
	padding: 30px;
	border-radius: 12px;
	text-align: center;
	overflow-y: scroll;
	height: 75vh;
}

.loading-message {
	margin-top: 15px;
}

.input-group {
	margin: auto;
	width: 100%;
	min-width: 10em;
}

.label-input {
	display: flex;
	flex-flow: row wrap;
	justify-content: center;
}

.label-input label,
.input-group .playable-label {
	max-width: 10em;
	flex: 0 1 auto;
	text-align: right;
}

.input-group input {
	flex: 0 1 auto;
}

#description,
#casino-name {
	flex: 1 1 auto;
}

fieldset p {
	text-align: left;
}

.button-group {
	display: flex;
	flex-flow: row nowrap;
	justify-content: center;
	margin-top: 10px;
}

option:checked {
    background: #5b88c0;
    color: white;
}

textarea {
	width: 32vw;
	height: 10vh;
}

@media (min-width: 768px) {
	#create-container {
		width: 50%;
	}

	.input-section fieldset {
		padding: 0.75em;
	}

	.label-input label,
	.input-group .playable-label {
		flex: 1 1 auto;
	}

	.input-group input {
		flex: 1 1 50%;
	}

	.label-input {
		flex-flow: row nowrap;
	}
}
@media (max-width: 768px) {
	#create-modal {
		left: 0%;
	}
	
	.label-input {
		display: grid;
		justify-content: center;
	}
}
</style>
